import { render, staticRenderFns } from "./Alibaba-product.vue?vue&type=template&id=48881fe8&"
import script from "./Alibaba-product.vue?vue&type=script&lang=js&"
export * from "./Alibaba-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports